import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BreadcrumbService {
  private breadcrumbProps = new Subject<{
    title: string;
    preTitle: string;
    eventDetailButtons: boolean;
    token: string;
  }>();
  propertyChanged$ = this.breadcrumbProps.asObservable();

  changeBreadCrumbProps(value: {
    title: string;
    preTitle: string;
    eventDetailButtons: boolean;
    token: string;
  }) {
    this.breadcrumbProps.next(value);
  }
}
